import {initProdTileCarousel} from './productTileCarousel';
import {forceLockScroll, forceUnlockScroll, preventDefault, genericAjaxCall} from '../util/common';

export {initProductTile, initSlotCarousel, closeAllQuickAdd};

// SELECTOR ELEMENT CLASS USED LIST
const PREVENT_DEFAULT = '.js-prevent-link';
const PRODUCT_GRID_PLP = '.js-plp-productGrid';
const PRODUCT_TILE = '.js-prodTile';
const QUICKADD_BUTTON = '.js-prodTile-quickAdd-button';
const QUICKADD_CLOSE = '.js-prodTile-quickAdd-modal-closeQuickAdd';
const QUICKADD_MODAL = '.js-prodTile-quickAdd-modal';
const QUICKADD_MODAL_OVERFLOW = '.js-prodTile-quickAdd-modal-overflow';
const QUICKADD_MODAL_SLIDER = '.js-quickAdd-modal-container';
const QUICKADD_PROCEEDBUTTON = '.js-prodTile-quickAdd-modal-confirmButton';
const QUICKADD_SIZEBUTTON = '.js-prodTile-quickAdd-modal-sizes-button';
const QUICKADD_SIZEBUTTON_SELECTED = '.js-prodTile-quickAdd-modal-size_selected';
const QUICKADD_SIZESELECTED_LABEL = '.js-prodTile-quickAdd-modal-sizeSelected';

let isOpened = false;

// LIST OF STYLE CLASS USED
const STYLE_QUICKADD_SIZEBUTTON_SELECTED =
    'cc-prodTile-quickAdd-modal-sizes-button_selected js-prodTile-quickAdd-modal-size_selected';
const QUICKADD_MODAL_OPEN = 'js-prodTile-quickAdd-modal_open';

function initProductTile() {
    if ($('.page').data('action') === 'Search-Show') {
        initOnlyPLP();
    } else {
        initProdTileCarousel();
        $(QUICKADD_BUTTON).off('click').on('click', openQuickAdd);
        $(PRODUCT_TILE).off('click').on('click', PREVENT_DEFAULT, preventDefault);
    }

    if ($('.js-suggestedProducts-container').length) {
        initSlotCarousel('.js-suggestedProducts-container');
    }

    if ($('.js-completeLook').length) {
        initSlotCarousel('.js-completeLook');
    }

    if ($('.js-completePromo').length) {
        initSlotCarousel('.js-completePromo');
    }

    $(window).on('resize', onResizeFunction);
}

function initSlotCarousel(containerClassName) {
    $(containerClassName)
        .off('click')
        .on('click', QUICKADD_BUTTON, openQuickAdd)
        .on('click', PREVENT_DEFAULT, preventDefault);

    if ($('.js-site-search').hasClass('cc-site-search_open') && !Foundation.MediaQuery.atLeast('large')) {
        $('.js-prodTile-quickAdd-modal').addClass('js-quickAdd-modal-container');
    }
}

function initOnlyPLP() {
    if ($(PRODUCT_GRID_PLP).length > 0) {
        initProdTileCarousel(PRODUCT_GRID_PLP);
        initSlotCarousel(PRODUCT_GRID_PLP);
        removeGridFullBanner();
    }
}

function removeGridFullBanner () {
    $('.cc-gridFullBanner-wrp').each(function (i, element) {
        if ($(element).children().length <= 0) {
            $(element).remove();
        }
    });
}

function openQuickAdd(e) {
    e.preventDefault();
    e.stopPropagation();

    let $this = $(this);
    let url = $(this).data('url');
    let $modal = $(this).siblings(QUICKADD_MODAL);
    let $modalForSlider = $(QUICKADD_MODAL_SLIDER);
    let isCompletePromo = false;

    // Needed because we have two modals in position fixed one inside the other
    if ($('.js-site-search').hasClass('cc-site-search_open') && !Foundation.MediaQuery.atLeast('large')) {
        $('.js-site-search').after($modalForSlider);
    }

    if ($(this).closest('.js-hpShoppable').length > 0) {
        if (Foundation.MediaQuery.atLeast('large')) {
            openQuickAddShoppable($this, url, $modal);
            return;
        } else {
            $modal = $modalForSlider.first();
        }
    } else if (
        $(this).closest('.cc-emCarouselEditProd').length > 0 &&
        !Foundation.MediaQuery.atLeast('large')
    ) {
        $modal = $modalForSlider.first();
    } else {
        if (
            $(this).closest('.slick-track').length &&
            $modalForSlider.length &&
            !Foundation.MediaQuery.atLeast('large')
        ) {
            $modal = $modalForSlider.first();
        } else if (
            $(this).closest('.cc-completeYourPromo-productCards, .cc-productCarousel-coreMedia').length > 0 &&
            !Foundation.MediaQuery.atLeast('large')
        ) {
            let $quickAddOutsideModal = $('.js-quickAdd-modal-container').eq(0).clone();
            if ($('body > .js-quickAdd-modal-container').length === 0) {
                $('body').prepend($quickAddOutsideModal);
            }

            if ($(this).closest('.cc-completeYourPromo-productCards').length > 0) {
                isCompletePromo = true;
            }

            $modal = $('body > .js-quickAdd-modal-container');
        }
    }

    genericAjaxCall(url, null, null, false).then(function (data) {
        var newDOMModal = $(data).clone();
        $modal.empty().html(newDOMModal);

        $modal.slideDown({
            start: function () {
                $modal.css({display: 'flex'}).addClass(QUICKADD_MODAL_OPEN);
                $('body').addClass('veiled-for-small-only');
                if (isCompletePromo) {
                    $('body').addClass('veiled-for-small-only_higher');
                }
            },
            complete: function () {
                $modal.on('click', QUICKADD_CLOSE, {modal: $modal}, closeQuickAdd);
                $modal.on('click', QUICKADD_SIZEBUTTON, {modal: $modal}, prepareAddToCart);
                searchSelectedSize($modal);
                if (!Foundation.MediaQuery.atLeast('large')) {
                    forceLockScroll();
                    // closeDrawerWithGesture($modal); comment for the moment
                }
            },
        });
    });
}

function openQuickAddShoppable($this, url, $modal) {
    if (!isOpened || !$modal.hasClass('quickAdd-opened')) {
        isOpened = true;
        genericAjaxCall(url, null, null, true).then(function (data) {
            var newDOMModal = $(data).clone();
            $modal.empty().html(newDOMModal);
            $modal
                .closest('.cc-emShoppable__productCard')
                .addClass('cc-emShoppable__productCard--opened quickAdd-opened');
            $modal.addClass('cc-customModalOpened');
            $('.cc-emShoppable__productCard:not(.cc-active)').removeClass('cc-emShoppable__productCard--opened quickAdd-opened');
            $('.cc-emShoppable__productCard:not(.cc-active)').find('.js-prodTile-quickAdd-modal').removeClass('cc-customModalOpened');
            $this.on('click', {modal: $modal}, closeQuickAddShoppable);
            $modal.on('click', QUICKADD_SIZEBUTTON, {modal: $modal}, prepareAddToCart);
            searchSelectedSize($modal);
        });
    }
}

function closeQuickAdd(e, $modal) {
    try {
        e.preventDefault();
    } catch (exc) {}

    if (!Foundation.MediaQuery.atLeast('large')) {
        forceUnlockScroll();
    }

    var modal = $modal ? $modal : e.data.modal;

    modal.slideUp({
        complete: function () {
            modal.removeClass(QUICKADD_MODAL_OPEN);
            $('body').removeClass('veiled-for-small-only veiled-for-small-only_higher');
        },
    });
    modal.off('click', QUICKADD_CLOSE).off('click', QUICKADD_SIZEBUTTON);
    modal.find(QUICKADD_PROCEEDBUTTON).off('click');
}

function closeQuickAddShoppable(e) {
    try {
        e.preventDefault();
        e.stopPropagation();
    } catch (exc) {}

    let $modal = e.data.modal;
    isOpened = false;
    $modal
        .closest('.cc-emShoppable__productCard')
        .removeClass('cc-emShoppable__productCard--opened quickAdd-opened');
    $modal.removeClass('cc-customModalOpened');
    $(QUICKADD_BUTTON).off('click');
    $modal.off('click', QUICKADD_CLOSE).off('click', QUICKADD_SIZEBUTTON);
    $modal.find(QUICKADD_PROCEEDBUTTON).off('click');
}

function closeDrawerWithGesture(modal) {
    var modalContainer = modal;

    const scrollElement = modalContainer.find(QUICKADD_MODAL_OVERFLOW)[0];

    var hammertime = new Hammer(modalContainer[0]);
    hammertime.get('swipe').set({direction: Hammer.DIRECTION_VERTICAL});
    hammertime.get('pan').set({direction: Hammer.DIRECTION_VERTICAL});

    const isScrollable = scrollElement.scrollHeight > scrollElement.clientHeight;

    var startY,
        scrollTop = 0;

    if (isScrollable) {
        let actionStart = false;
        hammertime.on('panstart', function (e) {
            actionStart = true;
            startY = e.deltaY - scrollElement.offsetTop;
            scrollTop = scrollElement.scrollTop;
        });
        hammertime.on('panend', function (e) {
            actionStart = false;
        });
        hammertime.on('panmove', function (e) {
            if (!actionStart) {
                return;
            }
            const y = e.deltaY - scrollElement.offsetTop;
            const scroll = y - startY;
            scrollElement.scrollTop = scrollTop - scroll;
        });
    }

    hammertime.on('swipedown', function (e) {
        if (isScrollable && (scrollElement.scrollTop !== 0 || scrollTop > 30)) {
            return;
        }

        closeQuickAdd(e, modal);
        hammertime.off('swipedown panmove panend panstart').destroy();
    });
}

/**
 * function for close all the quickadd open with screen device is in large breakpoint
 */
function closeAllQuickAdd() {
    let allQAopen = $('.' + QUICKADD_MODAL_OPEN);
    if (allQAopen.length > 0) {
        allQAopen.each(function () {
            closeQuickAdd(null, $(this));
        });
    }
}

function searchSelectedSize($modal) {
    var selectSize = $modal.find(QUICKADD_SIZEBUTTON_SELECTED);
    if (selectSize.length) {
        $modal.find(QUICKADD_SIZESELECTED_LABEL).empty().html(selectSize.data('name'));
    }
}

function prepareAddToCart(e) {
    var sizeButton = $(this);
    if (sizeButton.hasClass('notifyMe')) {
        return;
    }
    e.data.modal.find(QUICKADD_SIZEBUTTON).removeClass(STYLE_QUICKADD_SIZEBUTTON_SELECTED);
    sizeButton.addClass(STYLE_QUICKADD_SIZEBUTTON_SELECTED);

    const prepareData = {
        form: {
            pid: sizeButton.data('pid'),
            quantity: 1,
        },
        addToCartUrl: sizeButton.data('url'),
        modal: e.data.modal,
        $productContainer: sizeButton.closest('.js-prodTile'),
    };

    searchSelectedSize(e.data.modal);

    if (Foundation.MediaQuery.atLeast('large')) {
        // desktop version
        makeAddToCart({data: prepareData});
    } else {
        // mobile version
        e.data.modal
            .find(QUICKADD_PROCEEDBUTTON)
            .attr('disabled', false)
            .on('click', prepareData, makeAddToCart);
    }
}

function makeAddToCart(e) {
    let $modal = e.data.modal;
    var dataValue = e.data;
    genericAjaxCall(dataValue.addToCartUrl, 'POST', dataValue.form).then(function (data) {
        if (data.error === false) {
            $('body').trigger('product:afterAddToCart', {
                ...data,
                form: dataValue.form,
                $productContainer: dataValue.$productContainer,
            });
            handlePostCartAdd(data);

            if ($modal.closest('.js-hpShoppable').length > 0) {
                if (Foundation.MediaQuery.atLeast('large')) {
                    closeQuickAddShoppable(e);
                    return;
                }
            }

            closeAllQuickAdd();
        }
    });
}

function handlePostCartAdd(response) {
    $('body').trigger('count:update', response);
    // show add to cart toast
    if (response.error) {
        return;
    }
    if ($('.add-to-cart-messages').length === 0) {
        $('body').append('<div class="add-to-cart-messages"></div>');
    }
    if ($('.page[data-action="Cart-Show"]').length > 0) {
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }
        $('html').animate({scrollTop: 0}, 500);
    }
}

function onResizeFunction() {
    closeAllQuickAdd();
    forceUnlockScroll();
}
